import { render, staticRenderFns } from "./recipeDetails.vue?vue&type=template&id=048c3efe&"
import script from "./recipeDetails.vue?vue&type=script&lang=js&"
export * from "./recipeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports